/**
 * Labstep
 *
 * @module components/File/EmptyState
 * @desc Empty state for File
 */

import FileActionCreate from 'labstep-web/components/File/Action/Create';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { File } from 'labstep-web/models/file.model';
import type React from 'react';

export const FileEmptyState: React.FC = () => (
  <CardEmptyState
    src="/img/empty-state/files.svg"
    title={`No ${File.getHumanReadableEntityName(
      true,
      true,
    )} Uploaded`}
    explanation="All the files uploaded to experiments, protocols and resources in this workspace will appear here. Upload more files here, or via the Labstep Folder Watcher."
    action={<FileActionCreate multiple />}
  />
);
